import { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useFormik } from 'formik'
import { Text, Number } from 'components/input_fields'
import { SaveButton } from 'components/buttons'
import { EmergencyContactSchema } from './ValidationSchema'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { addEmergencyContact, updateEmergencyContact } from '../../../../redux/slices/help_desk/sos/Sos'
import { toggleBool } from '../../../../redux/slices/globalSlice'
import { addUpdateHandler } from 'utils'
import { useTranslation } from 'react-i18next'

export default function EmergencyContactForm({ contact, onCancel }) {

    const [spinner, setSpinner] = useState(false)
    const isEdit = Boolean(contact?.id)
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const initialValues = {
        id: contact?.id || '',
        name: contact?.user_name || '',
        mobile_number: contact?.user_mobile || '',
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: EmergencyContactSchema,
        onSubmit: (vals, action) => {
            setSpinner(true)
            const actionFn = isEdit ? updateEmergencyContact : addEmergencyContact
            dispatch(actionFn({ values: vals })).then((res) => addUpdateHandler({
                res: res.payload,
                action,
                navigate,
                success_toast: isEdit
                    ? `${t('sos.contact')} ${t('common.success_update')}`
                    : `${t('sos.contact')} ${t('common.success_add')}`,
                wrong_toast: t('common.wrong'),
                navigate_route: '',
                spinner: setSpinner,
                toggle: () => {
                    dispatch(toggleBool())
                    onCancel()
                },
            }))
        },
    })

    return (
        <Form onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
            <div className="sos-contact-form">
                <div className="row g-2">

                    <div className="col-md-6">
                        <Text
                            label_name={t('sos.name')}
                            mandatory={true}
                            placeholder={t('sos.name')}
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.name && touched.name ? <span className="field_error">{errors.name}</span> : null}
                        />
                    </div>

                    <div className="col-md-6">
                        <Number
                            label_name={t('sos.mobile_number')}
                            mandatory={true}
                            placeholder={t('sos.mobile_number')}
                            name="mobile_number"
                            value={values.mobile_number}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.mobile_number && touched.mobile_number ? <span className="field_error">{errors.mobile_number}</span> : null}
                        />
                    </div>

                </div>

                <div className="sos-form-actions">
                    <button type="button" className="sos-cancel-btn" onClick={onCancel}>
                        {t('common.cancel')}
                    </button>
                    <SaveButton button_name={t('common.submit')} spinner={spinner} />
                </div>
            </div>
        </Form>
    )
}
